import { jsx as g } from "react/jsx-runtime";
import { f as n } from "../../fuzzysort-eoXOpoo6.js";
const m = (r, t, h = "b") => {
  var i;
  return ((i = n.single(t, r)) == null ? void 0 : i.highlight((o, e) => /* @__PURE__ */ g(h, { children: o }, e))) ?? r;
};
export {
  m as highlightQueryInLabel
};
